(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["login-modal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('login-modal')) {
    class LoginModal extends HTMLElement {
      constructor() {
        super();
        this.dialog = null;
        this.observer = null;
      }

      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        
        if (!this.dialog) return;

        this.setupObserver();
        this.setupEventListeners();
      }

      setupObserver() {
        // Use MutationObserver to detect when modal opens/closes
        this.observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.attributeName === 'open') {
              if (this.dialog.hasAttribute('open')) {
                // Modal is open - lock scroll
                document.body.style.overflow = 'hidden';
              } else {
                // Modal is closed - unlock scroll
                document.body.style.overflow = '';
              }
            }
          });
        });

        // Start observing the dialog for attribute changes
        this.observer.observe(this.dialog, {
          attributes: true,
          attributeFilter: ['open']
        });
      }

      setupEventListeners() {
        // Unlock body scroll when modal closes (fallback)
        this.dialog.addEventListener('close', () => {
          document.body.style.overflow = '';
        });

        // Handle backdrop clicks to close modal
        this.dialog.addEventListener('click', (e) => {
          if (e.target === this.dialog) {
            this.dialog.close();
          }
        });

        // Handle mobile account button click
        const mobileAccountButton = document.querySelector('[data-open-login-modal]');
        if (mobileAccountButton) {
          mobileAccountButton.addEventListener('click', () => {
            this.dialog.showModal();
          });
        }
      }

      disconnectedCallback() {
        if (this.observer) {
          this.observer.disconnect();
        }
        document.body.style.overflow = '';
      }
    }

    customElements.define('login-modal', LoginModal);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    class StickyAddToCart extends HTMLElement {
    constructor() {
      super();
      this.observer = null;
      this.target = null;
      this.targetSelector = this.dataset.observeTarget || 'add-to-cart-component';
      this.abortController = null;
    }

    connectedCallback() {
      this.button = this.querySelector('[data-sticky-add-to-cart-button]');
      this.target = document.querySelector(this.targetSelector);
      this.abortController = new AbortController();
      this.setupObserver();
      this.setupButtonClick();
      this.setupVariantListener();
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
      this.abortController?.abort();
    }

    setupVariantListener() {
      document.addEventListener(
        'variant:update',
        (event) => this.onVariantUpdate(event),
        { signal: this.abortController.signal }
      );
    }

    onVariantUpdate(event) {
      const newAddToCartButton = event.detail.data.html?.querySelector('[ref="addToCartButton"]');
      if (!newAddToCartButton || !this.button) return;

      // Sync disabled state
      const isDisabled = newAddToCartButton.hasAttribute('disabled');
      this.button.disabled = isDisabled;

      // Sync button text
      this.button.textContent = newAddToCartButton.textContent.trim();

      // Update data-needs-size-selection based on whether variant is selected
      const hasVariant = event.detail.resource?.id != null;
      if (hasVariant) {
        this.removeAttribute('data-needs-size-selection');
      }
    }

    setupObserver() {
      if (!this.target) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              // Button is visible - hide sticky bar
              this.dataset.visible = 'false';
            } else {
              // Button is not visible - check if we've scrolled PAST it (it's above viewport)
              const rect = this.target.getBoundingClientRect();
              const isAboveViewport = rect.bottom < 0;
              this.dataset.visible = isAboveViewport.toString();
            }
          });
        },
        {
          threshold: 0,
          rootMargin: '0px'
        }
      );

      this.observer.observe(this.target);
    }

    setupButtonClick() {
      if (!this.button) return;

      this.button.addEventListener('click', () => {
        // Find and click the original add-to-cart button
        const originalButton = document.querySelector('add-to-cart-component [ref="addToCartButton"]');
        if (originalButton) {
          originalButton.click();
        }
      });
    }
  }

  if (!customElements.get('sticky-add-to-cart')) {
    customElements.define('sticky-add-to-cart', StickyAddToCart);
  }
  } catch(e) { console.error(e); }
})();

})();
